import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/analytics';
import 'firebase/performance';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: 'languagelearninglibrary-prod.firebaseapp.com',
  projectId: 'languagelearninglibrary-prod',
  storageBucket: 'languagelearninglibrary-prod.appspot.com',
  messagingSenderId: '636656689154',
  appId: '1:636656689154:web:b6a2e4dd1d2e3e1486071b',
  measurementId: 'G-FYJZTXV7XB',
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();
firebase.analytics();
firebase.performance();

export default firebase;
